// extracted by mini-css-extract-plugin
export default {"textarea":"TextArea_textarea__yLf29","error":"TextArea_error__tljoW","errorText":"TextArea_errorText__sYrbb"};